class FP_AffiliatesEarningsCalculator {
	constructor() {
		this.wrapper = document.querySelector('.fp-affiliates-earnings-calculator');
		this.clientsClass = '.fp-affiliates-earnings-calculator-clients';
		this.clients = this.wrapper.querySelector(this.clientsClass);
		this.total = this.wrapper.querySelector('.total');
		this.sliderClass = '.fp-affiliates-earnings-calculator-slider';
		this.slider = this.wrapper.querySelector(this.sliderClass);
		
		this.init();
	}

	init() {
		this.update(this.slider.value);

		document.addEventListener('input', function(e) {
			this.onClick(e);
		}.bind(this));

		document.addEventListener('click', function(e) {
			this.onClick(e);
		}.bind(this));
	}

	onClick(e) {
		let slider = e.target.closest(this.sliderClass);
		if (!slider) {
			return;
		}

		this.update(slider.value);
	}

	update(percent) {
		this.clients.innerHTML = percent;

		this.slider.style.background = `linear-gradient(to right, var(--accent-color) 0%, var(--accent-color) ${percent}%, var(--light-blue-5) ${percent}%, var(--light-blue-5) 100%)`;
		
		this.total.innerHTML = (parseInt(percent, 10) * this.getAveragePrice()).toLocaleString();
	}

	getAveragePrice() {
		const avg = ((39 + 59 + 89) / 3) * 0.3;
		
		return Math.round(avg);
	}
}

FP_Utils.onReady(function() {
	new FP_AffiliatesEarningsCalculator();
});